import type { Resource } from '../../';
export const country_countries_CH: Resource = {"default":"Switzerland"};
